// frontend/src/pages/CreateModule.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { BookOpen, HelpCircle, ArrowLeft } from "lucide-react";

export default function CreateModule() {
  const navigate = useNavigate();
  const [moduleName, setModuleName] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [error, setError] = useState("");
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 992);

  const handleModuleNameSubmit = (e) => {
    e.preventDefault();
    if (moduleName.trim().length < 3) {
      setError("Der Modulname muss mindestens 3 Zeichen lang sein.");
      return;
    }
    setError("");
    setShowOptions(true);
  };

  const handleLessonCreation = () => {
    // Navigate to lesson creation with module name
    navigate("/teacher/create-lesson", { state: { moduleName } });
  };

  const handleQuizCreation = () => {
    // Navigate to quiz creation with module name
    navigate("/teacher/create-quiz", { state: { moduleName } });
  };

  const handleBack = () => {
    if (showOptions) {
      setShowOptions(false);
    } else {
      navigate("/teacher/content");
    }
  };

  return (
    <main
      className="dashboard-main"
      style={{
        backgroundColor: "var(--bg-secondary)",
        minHeight: "100vh",
      }}
    >
      <Container className="py-4" style={{ maxWidth: "800px" }}>
        {/* Back Button */}
        <Button
          variant="link"
          className="mb-3 p-0 text-decoration-none"
          onClick={handleBack}
        >
          <ArrowLeft size={20} className="me-2" />
          Zurück
        </Button>

        <Card className="border-0 shadow-sm">
          <Card.Body className="p-4">
            {!showOptions ? (
              <>
                {/* Step 1: Module Name Input */}
                <div className="text-center mb-4">
                  <div
                    className="rounded-circle p-3 d-inline-flex"
                    style={{ backgroundColor: "#e3f2fd" }}
                  >
                    <BookOpen size={32} className="text-primary" />
                  </div>
                  <h3 className="mt-3 mb-2">Neues Modul erstellen</h3>
                  <p className="text-muted">
                    Geben Sie einen Namen für Ihr neues Modul ein
                  </p>
                </div>

                {error && <Alert variant="danger">{error}</Alert>}

                <Form onSubmit={handleModuleNameSubmit}>
                  <Form.Group className="mb-4">
                    <Form.Label className="fw-semibold">
                      Modulname <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="z.B. Grundlagen der Finanzwirtschaft"
                      value={moduleName}
                      onChange={(e) => setModuleName(e.target.value)}
                      size="lg"
                      autoFocus
                    />
                    <Form.Text className="text-muted">
                      Mindestens 3 Zeichen erforderlich
                    </Form.Text>
                  </Form.Group>

                  <div className="d-grid">
                    <Button
                      variant="primary"
                      type="submit"
                      size="lg"
                      disabled={moduleName.trim().length < 3}
                    >
                      Weiter
                    </Button>
                  </div>
                </Form>
              </>
            ) : (
              <>
                {/* Step 2: Content Type Selection */}
                <div className="text-center mb-4">
                  <h4 className="mb-2">Modul: {moduleName}</h4>
                  <p className="text-muted">
                    Was möchten Sie als erstes erstellen?
                  </p>
                </div>

                <div className="d-grid gap-3">
                  {/* Lesson Button */}
                  <Card
                    className="border-2 shadow-sm"
                    style={{ cursor: "pointer" }}
                    onClick={handleLessonCreation}
                  >
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded p-3 me-3"
                          style={{ backgroundColor: "#e3f2fd" }}
                        >
                          <BookOpen size={32} className="text-primary" />
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="mb-1">Lektion erstellen</h5>
                          <p className="text-muted mb-0 small">
                            Erstellen Sie Lernmaterialien, Texte und
                            Erklärungen für Ihre Schüler
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>

                  {/* Quiz Button */}
                  <Card
                    className="border-2 shadow-sm"
                    style={{ cursor: "pointer" }}
                    onClick={handleQuizCreation}
                  >
                    <Card.Body className="p-4">
                      <div className="d-flex align-items-center">
                        <div
                          className="rounded p-3 me-3"
                          style={{ backgroundColor: "#f3e5f5" }}
                        >
                          <HelpCircle size={32} style={{ color: "#9c27b0" }} />
                        </div>
                        <div className="flex-grow-1">
                          <h5 className="mb-1">Quiz erstellen</h5>
                          <p className="text-muted mb-0 small">
                            Erstellen Sie Fragen und Tests, um das Wissen Ihrer
                            Schüler zu überprüfen
                          </p>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </>
            )}
          </Card.Body>
        </Card>
      </Container>
    </main>
  );
}
